import {RouterModule, Routes} from "@angular/router";
import {AuthGuard} from "../../shared-module/seguridad/services/auth.guard";
import {NgModule} from "@angular/core";
import {CreacionMantenedorComponent} from "./views/creacion-mantenedor/creacion-mantenedor.component";
import {MotivoPedidoComponent} from "./views/motivo-pedido/motivo-pedido.component";
import {
  MantenedorSolicitudPedidoVentaComponent
} from "./views/mantenedor-solicitud-pedido-venta/mantenedor-solicitud-pedido-venta.component";
import {
  GestorSolicitudPedidoVentaComponent
} from "./views/gestor-solicitud-pedido-venta/gestor-solicitud-pedido-venta.component";


const autoconsumoRoutes: Routes = [
  {path: 'autogestion/creacion-mantenedor', component: CreacionMantenedorComponent, canActivate: [AuthGuard]},
  {path: 'autogestion/motivo-pedido', component: MotivoPedidoComponent, canActivate: [AuthGuard]},
  {
    path: 'autogestion/mantenedor-solicitud-pedido-venta',
    component: MantenedorSolicitudPedidoVentaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'autogestion/gestor-solicitud-pedido-venta',
    component: GestorSolicitudPedidoVentaComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(autoconsumoRoutes)],
  exports: [RouterModule]
})
export class AutoconsumoRoutingModule {
}
